import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { backend, API_URL } from "../../../config";
import { fetch_products_data_action } from "../../../redux/actions/products";
import { columnsConfig } from "../scripts/constants";

const useOrderlistData = () => {
  const dispatch = useDispatch();
  const productsStore = useSelector((state) => state.products);

  const [columns, setColumns] = useState(columnsConfig);
  const [products, setProducts] = useState([]);
  const [productsFull, setProductsFull] = useState([]);
  const [orderlists, setOrderlists] = useState([]);

  useEffect(() => {
    const productOrderlistGet = async () => {
      await backend.get(`${API_URL}productsbyorderlist`).then(({ data }) => {
        const allProducts = data.all_products;
        const orderlistsNames = data.order_list_names;

        if (orderlistsNames && orderlistsNames.length) {
          setOrderlists(orderlistsNames);

          const orderlistColumns = orderlistsNames.map((item) => ({
            id: item.order_list_id,
            label: item.company_location_name,
            minWidth: 20,
            align: "center",
            exposed: true,
            exposedAs: "checkbox",
          }));

          setColumns((prevState) => [...prevState, ...orderlistColumns]);
        }

        if (allProducts && allProducts.length) {
          // optimization: map for O(1) lookup instead of find O(n) per product
          const productsStoreMap = new Map(
            productsStore.map((p) => [p.upc, p]),
          );

          let individualRowProducts = [];
          allProducts.forEach((itemCode) => {
            itemCode.item_code.products.forEach((product) => {
              const productInfo = productsStoreMap.get(product.upc);
              const productObj = { ...product, ...productInfo };
              individualRowProducts.push(productObj);
            });
          });

          setProducts([individualRowProducts[0], ...individualRowProducts]);
          setProductsFull([individualRowProducts[0], ...individualRowProducts]);
        }
      });
    };

    if (!productsFull.length && !orderlists.length && productsStore.length) {
      productOrderlistGet();
    }
  }, [productsFull, productsStore, orderlists]);

  useEffect(() => {
    if (!productsStore.length) {
      dispatch(fetch_products_data_action(productsStore));
    }
  }, [dispatch, productsStore]);

  return {
    columns,
    setColumns,
    products,
    setProducts,
    productsFull,
    setProductsFull,
    orderlists,
  };
};

export default useOrderlistData;
